import { gql } from '@apollo/client'

export const getResidentQuery = gql`
  query GetResident($residentId: String!) {
    resident(residentId: $residentId) {
      id
      created_at
      updated_at
      first_name
      last_name
      date_of_birth
      email
      phone {
        country_code
        phone_number
      }
    }
  }
`

export const getTermsAndConditionsAcceptanceQuery = `
  query GetTermsAndConditionsAcceptance($personId: String!, $corporationId: String!) {
    termsAndConditionsAcceptance(personId: $personId, corporationId: $corporationId) {
      terms_and_conditions_acceptance_id
      terms_of_service_version_id
      privacy_policy_version_id
    }
  }
`

export const getActiveTermsOfServiceVersionQuery = `
  query GetActiveTermsOfServiceVersion {
    activeTermsOfServiceVersion {
      terms_of_service_version_id
      version_text
    }
  }
`

export const getActivePrivacyPolicyVersionQuery = `
  query GetActivePrivacyPolicyVersion {
    activePrivacyPolicyVersion {
      privacy_policy_version_id
      version_text
    }
  }
`

export const getManagementFeePoliciesQuery = `
  query ManagementFeePolicies($doorId: String!, $policyTypeIds: [String!]!) {
    managementFeePolicies(doorId: $doorId, policyTypeIds: $policyTypeIds) {
      policy {
        management_fee_policy_id
        policy_name
        policy_type_id
      }
    }
  }
`
